import React from 'react';

import { ReactComponent as BinIcon } from '../../../../assets/images/bin.svg';
import { ReactComponent as EditIcon } from '../../../../assets/images/pencil.svg';
// import { ReactComponent as ReferIcon } from '../../../../assets/images/Refer.svg';
import ColumnFilter from '../../../../components/ColumnFilter/ColumnFilter';
import ContactSources from '../../../../components/ContactSources/ContactSources';
import Menu from '../../../../components/shared/Menu/Menu';

import styles from './ContactsTable.module.scss';

const RecommendationsCell = ({ contactId, hasRecommendations, onNavigate, viewLabel, noneLabel }) => {
  if (!hasRecommendations) {
    return <span className={styles.noRecommendations}>{noneLabel}</span>;
  }
  return (
    <button
      type="button"
      className={styles.recommendationsBtn}
      onClick={(e) => {
        e.stopPropagation();
        onNavigate(contactId);
      }}
    >
      {viewLabel}
    </button>
  );
};

const ContactsColumnHeaders = (handleOpenModal, count, toggleDeleteOption, t, onViewRecommendations) => [
  {
    Header: t('tableHeaders.id'),
    accessor: 'id',
    Filter: ColumnFilter,
    disableFilters: true,
  },
  {
    Header: t('tableHeaders.contacts', { count: count || 0 }),
    accessor: 'full_name',
    Filter: ColumnFilter,
    Cell: ({ value, row }) => (
      <span className={styles.contactName} onClick={() => handleOpenModal(row.original)} role="presentation">
        {value}
      </span>
    ),
  },
  {
    Header: t('tableHeaders.jobTitle'),
    accessor: 'job_title',
    Filter: ColumnFilter,
  },
  {
    Header: t('tableHeaders.email'),
    accessor: 'user_contact_emails_attributes',
    Filter: ColumnFilter,
    Cell: ({ value }) => <span className={styles.tag}>{!!value.length && value[0].email}</span>,
  },
  {
    Header: t('tableHeaders.contactsSource'),
    accessor: 'source',
    Filter: ColumnFilter,
    Cell: ({ value }) => <ContactSources sources={value} />,
  },
  {
    Header: t('tableHeaders.recommendations'),
    accessor: 'has_recommendations',
    Filter: ColumnFilter,
    disableFilters: true,
    Cell: ({ value, row }) => (
      <RecommendationsCell
        contactId={row.original.id}
        hasRecommendations={value}
        onNavigate={onViewRecommendations}
        viewLabel={t('view')}
        noneLabel={t('none')}
      />
    ),
  },
  {
    Header: t('tableHeaders.referralsSent'),
    accessor: 'referrals_count',
    Filter: ColumnFilter,
    Cell: ({ value, row }) => (
      <div className={styles.referralsCont}>
        <p className={styles.count}>{value || 0}</p>
        <Menu
          items={[
            // {
            //   title: t('refer'),
            //   action: () => {},
            //   icon: ReferIcon,
            //   isColorPrimary: true,
            // },
            {
              title: t('edit'),
              action: () => handleOpenModal(row.original),
              icon: EditIcon,
            },
            {
              title: t('delete'),
              action: () => toggleDeleteOption(row.original),
              icon: BinIcon,
            },
          ]}
        />
      </div>
    ),
  },
];

export default ContactsColumnHeaders;
